/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {fixDanglingInstrumentLinkStatus} from '../api'

export const useMutationFixDanglingInstrumentLinkStatus = createReactQueryMutationHook('fixDanglingInstrumentLinkStatus', fixDanglingInstrumentLinkStatus)
